import { RenterNextPayableInterface, RenterNextPayableNumericInputInterface } from './Types';
import { formatTimestampToYMDString } from '@common/paymentsUtils/dateUtils';

const NextPayableModel = (nextPayable: RenterNextPayableNumericInputInterface): RenterNextPayableInterface => {
  const {
    scheduleMonth = '',
    dueDate = 0,
    numberOfPaymentsRemaining = 0,
    amount = 0,
    fee = 0,
    totalAmount = 0,
    isScheduled = true,
  } = nextPayable || {};

  return {
    scheduleMonth,
    dueDate: formatTimestampToYMDString(dueDate),
    numberOfPaymentsRemaining: numberOfPaymentsRemaining && Number(numberOfPaymentsRemaining),
    amount: amount && Number(amount),
    fee: fee && Number(fee),
    totalAmount: totalAmount && Number(totalAmount),
    isScheduled,
  };
};

export default NextPayableModel;
